import Image from 'next/image';
import useEmblaCarousel from 'embla-carousel-react';
import { useGSAP } from '@gsap/react';
import { useRef } from 'react';
import gsap from 'gsap';



export function PressCarousel({ items }) {
  const [emblaRef] = useEmblaCarousel({ align: 'start' });
  const itemsRefs = useRef([]);


    useGSAP(() => {
    const mm = gsap.matchMedia();

    mm.add("(min-width: 1280px)", () => {


      const offsets = [10, 30, 20, 15];

      itemsRefs.current.forEach((item, index) => {
        const initialY = offsets[index] !== undefined ? offsets[index] : 0;

        gsap.fromTo(item, {
          y: `${initialY}rem`,

        }, {
          y: 0,
          duration: 1,
          delay: index * 0.1,
          scrollTrigger: {
            trigger: item.parentElement,
            start: "top 100%",
            end: "top 40%",
            // markers: true,
            scrub: 0.5
          },
        });


        const imageElement = item.querySelector('img');
        if (imageElement) {
          gsap.fromTo(imageElement, {
            y: '-1rem',
          }, {
            y: '1rem',
            ease: "none",
            scrollTrigger: {
              trigger: item.parentElement,

              start: "top 80%",
              end: "top 20%",
              scrub: 0,
            },
          });
        }

      });


    });

    return () => mm.revert();
  }, [items]); 

  return (
    <>
          <div className="embla lg:hidden md:px-[2.4rem] container-padding" ref={emblaRef}>
            <div className="embla__container  gap-[1.2rem] md:gap-[1.6rem]">
              {items.map((item, index) => (
                <div key={index} className="embla__slide  flex flex-col items-stretch w-[calc(100%-4rem)] flex-[0_0_31.6rem] md:flex-[0_0_59.6rem]">
                  <div className="relative aspect-[2.59/1] w-full">
                    <Image
                      src={item.image.url}
                      alt={item.image?.alt}
                      fill
                      sizes="(max-width: 768px) 31.6rem,(max-width: 1280px) 59.6rem, 33vw"
                      className="w-auto object-cover"
                    />
                  </div>

                  <div className="bg-white flex flex-col justify-between flex-1 p-[2rem]">
                    <div>
                      <h3 className="heading-4 mb-[1.6rem]">{item.title.length > 100
                  ? item.title.slice(0, item.title.slice(0, 100).lastIndexOf(' ')) + '…'
                  : item.title}</h3>
                      <p className="text-1 mb-[5.2rem]">              {item.description.length > 200
                  ? item.description.slice(0, item.description.slice(0, 200).lastIndexOf(' ')) + '…'
                  : item.description}</p>
                    </div>

                    <a href={item.link} className="text-link ">Перейти к статье</a>
                  </div>
                </div>
              ))}
            </div>
          </div>


          <div className="hidden lg:flex container-padding">
            <div className=" flex gap-[3.6rem] items-stretch lg:5.6rem">
              {items.map((item, index) => (
                <a  href={item.link} rel={'nofollow'}   target={'_blank'}   ref={(el) => {
                if (el) itemsRefs.current[index] = el;
              }} key={index} className="group flex-1 flex flex-col h-full">
                  <div className="overflow-hidden flex  items-center aspect-[2.59/1] w-full">
                    <div className='h-[120%] w-full relative'>
                      <Image
                        src={item.image.url}
                        alt={item.image?.alt}
                        fill
                        sizes="600px"
                        className="w-auto object-cover"
                      />
                    </div>
                  </div>

                  <div className="flex-1 justify-between flex flex-col bg-white group-hover:bg-dusty-green-light transition-colors duration-300 p-[2rem] xl:px-[3.2rem] lg:py-[3.2rem]">
                    <div>
                      <h3 className="heading-4 mb-[1.6rem]">{item.title.length > 100
                  ? item.title.slice(0, item.title.slice(0, 100).lastIndexOf(' ')) + '…'
                  : item.title}</h3>
                      <p className="text-1 mb-[5.2rem]">              {item.description.length > 120
                  ? item.description.slice(0, item.description.slice(0, 120).lastIndexOf(' ')) + '…'
                  : item.description}</p>
                    </div>


                    

                    <p  className="text-link xl:text-[1.8rem] ">Перейти к статье</p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </>
  );
}
